import { render, staticRenderFns } from "./LiveGamesTable.vue?vue&type=template&id=0aafb0f4&scoped=true&"
import script from "./LiveGamesTable.vue?vue&type=script&lang=js&"
export * from "./LiveGamesTable.vue?vue&type=script&lang=js&"
import style0 from "./LiveGamesTable.vue?vue&type=style&index=0&id=0aafb0f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aafb0f4",
  null
  
)

export default component.exports